module.exports = __webpack_public_path__ + "img/17_maska_kot.1f5ae26.svg";